// extracted by mini-css-extract-plugin
export default {"melodyVideo":"YJ-z","isFullWidth":"ZJ-z","landingPageVideo":"_J-z","play":"aK-z","iframeVideo":"bK-z","playHidden":"cK-z","fullwidth":"dK-z"};